import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["item", "button"]
    static values = {
        moreText: String,
        lessText: String,
        expandOnly: { type: Boolean, default: false }
    }

    connect() {
        this.expanded = false
        this.updateItems()
        this.updateButtonText()
    }

    toggle() {
        if (this.expandOnlyValue) {
            this.expanded = true
            this.updateItems()

            if (this.hasButtonTarget) {
                this.buttonTarget.style.display = "none"
            }
        } else {
            this.expanded = !this.expanded
            this.updateItems()
            this.updateButtonText()
        }
    }

    updateItems() {
        this.itemTargets.forEach((el) => {
            el.style.display = this.expanded || el.dataset.visible === "true" ? "inline-flex" : "none"
        })
    }

    updateButtonText() {
        if (!this.hasButtonTarget) return

        this.buttonTarget.textContent = this.expanded
            ? this.lessTextValue
            : this.moreTextValue
    }
}
